import React from "react";

/** Three grey rows while a profile list loads. */
const ProfileListSkeleton = () =>
    [1, 2, 3].map((row) => (
        <div key={row} className={"flex gap-4 px-5 py-4 border-b last:border-b-0"}>
            <div className={"my-auto"}>
                <div className="w-5 h-5 rounded border-2 border-gray-200 bg-gray-100 animate-pulse"></div>
            </div>
            <div className={"my-auto flex-1"}>
                <div className={"h-4 bg-gray-200 rounded w-32 animate-pulse"}></div>
                <div className={"h-3 bg-gray-100 rounded w-48 mt-2 animate-pulse"}></div>
            </div>
        </div>
    ));

export default ProfileListSkeleton;
